export const wildcardCapability = [
  'contracts@*',
  'users@*',
  'customers@*'
] as const

type WildcardCapability = (typeof wildcardCapability)[number]

export default WildcardCapability
